<template>
	<div class="achievement">
		<ximg
			:src="convertToAchievementUrl(achievement.imageName, 95, 93)"
			:fallback="convertToAchievementUrl('404', 95, 93)"
			lazy
			:ariaLabel="'achievement image ' + achievement.name"
			role="img"
		/>
		<img
			class="achievement-icon-rarity"
			alt="achievement icon rarity"
			:title="achievement.rarity"
			:src="convertToCdnUrl(rarityImgSrc)"
		/>
		<h3 class="achievement-title">
			{{ achievement.name }}
			<span v-if="isNew" class="new-text">{{ t('NEW') }}</span>
		</h3>
		<span class="achievement-xp">{{ formatNumber(achievement.experiencePoints) }} XP</span>
		<span class="achievement-description">
			{{ achievement.isSecret ? ta('IS_SECRET') : achievement.description }}
		</span>
	</div>
</template>

<script>
import { t } from 'datastore/i18n';
import { formatNumber, convertToCdnUrl, convertToAchievementUrl } from 'utils';

export default {
	props: ['achievement'],
	methods: {
		convertToCdnUrl,
		convertToAchievementUrl,
		t,
		ta: t.prefix('ACHIEVEMENT'),
		formatNumber,
	},
	computed: {
		isNew () {
			if (! this.achievement.modifiedAt) {
				return false;
			}
			return (
				this.achievement.modifiedAt &&
				this.achievement.achievedPercentage === 1 &&
				this.achievement.modifiedAt > (Date.now() / 1000) - 60 * 60 * 24 * 30
			);
		},
		rarityImgSrc () {
			let url = '/img/no-image.svg';
			if (this.achievement.rarity.toLowerCase() !== 'n/a') {
				url = '/img/member/achievements/rarity/' + this.achievement.rarity.toLowerCase() + '.png';
			}
			return url;
		},
	},

};
</script>
